import React from 'react';
import { Section, SectionHeading } from './Shared';
import { testimonials, type Testimonial } from '../data/testimonials';
export function TestimonialCard({
  initials,
  name,
  location,
  role,
  text
}: Testimonial) {
  return <article className="flex h-full flex-col rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-id="element-226" data-mp="3fyco1fyxbt7m">
      <div className="mb-3 flex items-center gap-3" data-id="element-227" data-mp="3b01g5as6vss1">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-50 font-bold text-emerald-700" data-id="element-228" data-mp="36zimdb6qkcn7">
          {initials}
        </div>
        <div data-id="element-229" data-mp="321z665qh9psm">
          <p className="font-semibold text-stone-900" data-id="element-230" data-mp="2x0tgkgs46inb">{name}</p>
          <p className="text-xs text-stone-500" data-id="element-231" data-mp="2x1bgpohwdh0i">
            {location} · {role}
          </p>
        </div>
      </div>
      <p className="text-[15px] leading-relaxed text-stone-700" data-id="element-232" data-mp="2s3t5tskbkrpv">
        “{text}”
      </p>
    </article>;
}
export function InitialTestimonials() {
  return <Section className="pt-6" data-id="element-233" data-mp="qbesz7wmudgb">
      <SectionHeading character="證" className="mb-3" data-id="element-234" data-mp="qb4zhacdpo5v">
        TESTIMONIOS DE TERAPEUTAS
      </SectionHeading>
      <p className="mx-auto mb-6 max-w-2xl text-center text-sm text-stone-500 md:text-base" data-id="element-235" data-mp="h8145e8mjyfq">
        Experiencias de profesionales que ya utilizaron materiales anteriores de
        Medicina China de Lumen Akasha.
      </p>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-3 md:grid-cols-3 md:gap-4" data-id="element-236" data-mp="c6ll1rq0c1zz">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-237" data-mp="zw65yg5q19bw" />)}
      </div>
    </Section>;
}